import IconCross from '@/assets/svg/purge/icons/icon-cross.svg'

import { TagProps } from './ts'

function Tag({ value, onRemove }: TagProps) {
  return (
    <div className="flex items-center space-x-2.5 px-4 py-2.5 rounded-lg bg-violet-15 select-none flex-shrink-0">
      <span className="text-sm font-medium text-black">{value}</span>
      <button
        className="w-4 h-4 text-black focus:outline-none hover:text-violet-200"
        type="button"
        onClick={onRemove}
      >
        <IconCross />
      </button>
    </div>
  )
}

export default Tag
